'use client';
import React, { useState } from 'react';
import { Star } from 'lucide-react';

interface StarRatingProps {
  value: number;
  max?: number;
  interactive?: boolean;
  onChange?: (val: number) => void;
  size?: number;
}

export default function StarRating({
  value,
  max = 5,
  interactive = false,
  onChange,
  size = 16,
}: StarRatingProps) {
  const [hovered, setHovered] = useState(0);

  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: max }, (_, i) => i + 1).map((star) => {
        const filled = interactive ? (hovered || value) >= star : value >= star;
        return (
          <button
            key={`star-${star}`}
            type="button"
            disabled={!interactive}
            onClick={() => interactive && onChange?.(star)}
            onMouseEnter={() => interactive && setHovered(star)}
            onMouseLeave={() => interactive && setHovered(0)}
            className={`transition-colors duration-100 ${interactive ? 'cursor-pointer' : 'cursor-default'}`}
          >
            <Star
              size={size}
              className={filled ? 'text-amber-400 fill-amber-400' : 'text-muted-foreground/30'}
            />
          </button>
        );
      })}
    </div>
  );
}